import type {
  ModalIbanAccountStep,
  monthlyIncome,
  QuizResponses,
  QuizStepProps
} from "@/features/user/quiz/types.ts";
import { useTranslation } from "react-i18next";
import { Base, SectionTitleSmall } from "@/atoms-react/text/Text.react.tsx";
import { RadioCard } from "@/atoms-react/radio-card/index.react.tsx";
import DotsNavigation from "@/atoms-react/dots-navigation/DotsNavigation.react.tsx";
import { Button } from "@/atoms-react/button/Button.react.tsx";
import { Themes } from "@/types/theme.ts";

export const MonthlyIncomeStep = ({
  setStep,
  quizResponses,
  setQuizResponses,
  stepSettings,
  setPrevStep,
  totalSteps = 8
}: QuizStepProps) => {
  const { t } = useTranslation(["pass"]);
  const monthlyIncomes = [
    {
      trans_key: "less_1500",
      minimum: 0,
      maximum: 1500
    },
    {
      trans_key: "between_1500_and_5000",
      minimum: 1500,
      maximum: 5000
    },
    {
      trans_key: "between_5000_and_10000",
      minimum: 5000,
      maximum: 10000
    },
    {
      trans_key: "more_10000",
      minimum: 10000,
      maximum: null
    }
  ];
  const handleRadioBoxChange = (checkedMonthlyIncomesState: monthlyIncome) =>
    setQuizResponses?.((prevState) => ({
      ...(prevState as QuizResponses),
      monthly_income: { ...checkedMonthlyIncomesState }
    }));

  const isQuizAnswered = () =>
    quizResponses?.monthly_income && Object.keys(quizResponses?.monthly_income).length !== 0;
  return (
    <>
      <SectionTitleSmall>
        {t("olkypass.mainPage.olkypass.modalOpenOlkyPay.steps.monthly_incomes.question")}
      </SectionTitleSmall>
      <div className="my-4 mt-4 grid grid-cols-1 gap-2 md:grid-cols-2">
        {monthlyIncomes.map((m) => (
          <RadioCard
            active={
              (quizResponses?.monthly_income &&
                quizResponses?.monthly_income?.trans_key === m.trans_key) as boolean
            }
            key={m.trans_key}
            onClick={() => handleRadioBoxChange(m)}
          >
            <Base>
              {t(
                "olkypass.mainPage.olkypass.modalOpenOlkyPay.steps.monthly_incomes.responses." +
                  m.trans_key
              )}
            </Base>
          </RadioCard>
        ))}
      </div>
      <div className="mt-auto mb-4 flex flex-col items-center">
        <DotsNavigation total={totalSteps} current={stepSettings.current} className="mb-4" />
        <div className="flex w-full flex-col-reverse gap-y-2 md:flex-row md:gap-x-2">
          <Button
            theme={Themes.white}
            onClick={() => setPrevStep(stepSettings.previous as ModalIbanAccountStep)}
          >
            {t("olkypass.general.go_back")}
          </Button>

          <Button
            disabled={!isQuizAnswered()}
            onClick={() => setStep(stepSettings.next as ModalIbanAccountStep)}
          >
            {t("olkypass.general.continue")}
          </Button>
        </div>
      </div>
    </>
  );
};
